import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Sidebar() {
    const navigate = useNavigate();

    function handleLogout() {
        localStorage.removeItem('token');
        navigate('/');
    }

    return (
        <div className="sidebar">
            <h2>Findows 2000™</h2>
            <nav>
                <Link to="/dashboard">📊 Dashboard</Link>
                <Link to="/stocks">📈 Stocks</Link>
                <Link to="/metrics">📡 API Metrics</Link>
                <Link to="/admin">⚙️ Admin</Link>
            </nav>
            <button className="logout-btn" onClick={handleLogout}>🚪 Logout</button>
        </div>
    );
}

export default Sidebar;
